import React from "react";
import "../styles/blog2.css";

import { useState } from "react";
import { Link } from "react-router-dom";

const Blog2 = () => {
  const [hover, setHover] = useState(false);

  return (
    <main
      className="main-section"
      style={{ maxWidth: 1200, margin: "120px auto 40px auto", padding: 24 }}
    >
      <Link
        to="/blogs"
        style={{
          background: hover ? "#f96e2a" : "#fff",
          border: "1.5px solid #f96e2a",
          borderRadius: 20,
          padding: "7px 22px",
          color: hover ? "#fff" : "#f96e2a",
          fontWeight: 500,
          marginBottom: 28,
          cursor: "pointer",
          boxShadow: "0 2px 14px #f7c69c15",
          textDecoration: "none",
          display: "inline-block",
          transition: "all 0.18s",
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        ← Back to Blogs
      </Link>
      <section className="blog-article">
        <div className="blog-article-header">
          <img
            className="blog-author-photo"
            src={require("../assets/blogs/pranav-rana.webp")}
            alt="Pranav Rana, CFP"
          />
          <div className="blog-author-info">
            <span className="blog-author-name">Pranav Rana, CFP</span>
            <span className="blog-author-role">Wealth Manager, Serenityy</span>
          </div>
        </div>
        <h2 className="blog-article-title">
          What Does a Financial Planner Really Do?{" "}
        </h2>
        <span style={{ fontWeight: 400, fontStyle: "italic" }}>
          It’s More Than Just Investing Your Money
        </span>
        <p style={{ fontSize: "0.95rem", opacity: 0.7 }}>
          Posted on 4 July 2025
        </p>
        <p>
          This is what I have been doing for the last 10 years working with
          major financial institutions and brokerage firms. When people hear the
          term financial planner, they often picture someone who simply tells
          you where to invest, usually in mutual funds, stocks, or some trendy
          product. Others believe financial planning is only for the wealthy
          individuals.
          <br />
          <br />
          But that couldn’t be further from the truth.
          <br />A skilled financial planner is more like a{" "}
          <b>life strategist with a calculator</b>. Someone who understands your
          dreams, values, challenges, and lifestyle, and helps you create a
          structured roadmap toward achieving them.
        </p>

        <h3>
          Let’s break down what a financial planner truly does and how it
          impacts every stage of life:
        </h3>

        <ol>
          <li>
            <b>Clarifying Your Life Goals</b>
            <p>
              Financial planning doesn’t start with numbers. It starts with you.
              <br />
              Your goals might include buying a home, saving for your children’s
              education, achieving financial freedom, or enjoying a stress-free
              retirement. But even beyond that, it’s about understanding what
              really matters to you and building your plan around it.
            </p>
            <p>
              When I was 20 and just starting my professional journey, my goals
              were simple but meaningful — buying a bike, saving consistently,
              wearing good branded clothes and shoes, and supporting my family
              with monthly expenses. Those early aspirations shaped how I viewed
              money and how I began planning for bigger milestones later.
            </p>
          </li>
          <li>
            <b>Creating a Personalized Strategy</b>
            <p>
              There’s no such thing as a “universal” financial plan.
              <br />A financial planner creates a strategy specifically for you
              considering your income, lifestyle, risk appetite, family
              responsibilities, and future dreams. It’s not just about what you
              invest in, but why, how, and when.
            </p>
            <p>
              Being young and without major responsibilities, I could afford to
              take more risks and that allowed me to accelerate my
              wealth-building journey. But my father, who had a family to
              support, required a more stable, conservative approach. One size
              definitely doesn’t fit all.
            </p>
          </li>
          <li>
            <b>Optimizing Your Taxes</b>
            <p>
              Tax planning shouldn’t be a last-minute scramble in March. It
              should be an ongoing strategy.
              <br />A financial planner helps you minimize tax liabilities,
              leverage deductions, and maximize tax-efficient investments
              throughout the year giving you more to save, invest, and spend.
            </p>
            <p>
              Tax-saving isn’t a one-time trick. Spreading your planning across
              the year, but staggering and grabbing opportunities over the whole
              year make it easy and rewarding.
            </p>
          </li>
          <li>
            <b>Balancing Risk and Return</b>
            <p>
              High returns sound great, until markets crash.
              <br />A seasoned financial planner doesn’t just chase returns;
              they help you strike the right balance between growth and
              protection. The goal is to create a portfolio that performs over
              time and allows you to sleep peacefully even during volatility.
            </p>
            <p>
              Investing doesn’t mean putting everything into stocks. During
              COVID, for instance, debt instruments, fixed deposits, and bonds
              offered more stability than equities. Diversification helped
              protect my portfolio peace of mind.
            </p>
          </li>
          <li>
            <b>Planning for Your Family’s Future</b>
            <p>
              Financial planning isn’t just about you, it’s also about the
              people who depend on you.
              <br />A financial planner helps you protect your loved ones
              through the right insurance, estate planning, and contingency
              strategies ensuring that your legacy is secure.
            </p>
            <p>
              I bought life insurance early in my career when premiums were
              affordable and I was healthy. As my responsibilities grew, so did
              my coverage. Today, I make sure I’m insured for at least 10 times
              my annual income, a rule I recommend to everyone. Waiting too long
              to buy insurance or underestimating your needs can be a costly
              mistake.
            </p>
          </li>
        </ol>

        <p style={{ fontSize: "0.95em" }}>
          <br />A financial planner isn’t just a money expert. They’re a guide,
          an educator, and a partner in your financial journey. They help you
          stay focused, make smart decisions, avoid emotional mistakes, and
          adapt to life’s changes with confidence.
        </p>
        <p style={{ fontSize: "0.95em" }}>
          They don’t just help you grow wealth, they help you build a life of
          clarity, purpose, and peace. Whether you're just starting out or
          preparing to pass on your legacy, a trusted financial planner can help
          turn your goals into reality.
        </p>
      </section>
    </main>
  );
};

export default Blog2;
